import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=4600ca3c&scoped=true"
import script from "./copy.vue?vue&type=script&lang=js"
export * from "./copy.vue?vue&type=script&lang=js"
import style0 from "./copy.vue?vue&type=style&index=0&id=4600ca3c&prod&lang=stylus&scoped=true"
import style1 from "./copy.vue?vue&type=style&index=1&id=4600ca3c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4600ca3c",
  null
  
)

export default component.exports